import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import api from "@/utils/backend-api"
import user from './modules/user'
import orders from "./modules/orders";
import workers from "./modules/workers";
import pdfchecks from "./modules/pdfchecks";
import mailchecks from "./modules/mailchecks";
import blacklist from "./modules/blacklist";
import contragents from "./modules/contragents";
import filters from "./modules/filters";
import dashboard from "./modules/dashboard";
import inform from "./modules/inform";
Vue.use(Vuex)


export default new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage })], // !debug ? [createPersistedState({ storage: window.sessionStorage })] : [],
  modules: {
    user,
    orders,
    workers,
    pdfchecks,
    mailchecks,
    blacklist,
    filters,
    dashboard,
    inform,
    contragents,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js